import React from "react";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { UseFormReturn } from "react-hook-form";
import type { Company } from "@/types/auth";

interface CompanyTypeSelectProps {
  form: UseFormReturn<Company>;
  isSubmitting: boolean;
  apiError?: { detail?: { [key: string]: string[] } };
}

export function CompanyTypeSelect({ form, isSubmitting, apiError }: CompanyTypeSelectProps) {
  return (
    <FormField
      control={form.control}
      name="company_type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Company Type</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value} disabled={isSubmitting}>
            <FormControl>
              <SelectTrigger className={apiError?.detail?.company_type ? "border-red-500" : ""}>
                <SelectValue placeholder="Select company type" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="ECOMMERCE">E-commerce</SelectItem>
              <SelectItem value="RETAILER">Retailer</SelectItem>
              <SelectItem value="BOTH">Both</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}